import { useSnackbar } from 'notistack';
import { useMutation } from 'react-query';

import { axios } from 'lib';

const createLot = (resource, id, values) => {
  return axios.post(`/api/${resource}/${id}/setup/lots`, values);
};

export const useCreateLot = (resource, id, onSuccess) => {
  const { enqueueSnackbar } = useSnackbar();

  return useMutation({
    mutationFn: (values) => createLot(resource, id, values),
    onSuccess: () => {
      enqueueSnackbar('Lot successfully added', { variant: 'success' });
      onSuccess();
    },
    onError: (error) => {
      enqueueSnackbar(error?.response?.data?.description || error?.message || 'Some error occured', {
        variant: 'error',
      });
    },
  });
};
